import React from "react";

export default function Card({ children, className = "" }) {
  return (
    <div className={`p-5 rounded-2xl border bg-white shadow-sm ${className}`}>
      {children}
    </div>
  );
}
